const TOOL_ERROR_TEXTS = {
	LLM_BUDGET_EXHAUSTED:
		'Das Kostenlimit des Laufs für Modellaufrufe ist erreicht; dieses Werkzeug steht nicht mehr zur Verfügung.',
	OPERATION_OPEN: 'Für dieses Werkzeug läuft bereits ein Hintergrundjob dieses Laufs.',
	RUN_NOT_RUNNING: 'Der Lauf ist nicht mehr aktiv.',
	ACTION_ID_REUSED: 'Der Aufruf wurde mit anderer Eingabe wiederholt und abgelehnt.',
	NO_MANDATE: 'Der Lauf hat kein Mandat.',
	MANDATE_EXPIRED: 'Das Mandat ist abgelaufen.',
	MAPS_NOT_ALLOWED: 'Das Mandat erlaubt keine externe Suche.',
	MANDATE_EXCEEDED: 'Die Anfrage überschreitet das Mandat.',
	NO_LIST_IN_MANDATE: 'Das Mandat nennt keine Zielliste.',
	NOTHING_BOUGHT: 'Noch keine Firmen in der Liste.',
	NOTHING_TO_BUY:
		'Keine passende Firma für die Liste: Die Suche hat nichts gefunden oder keine Firma wurde als passend geprüft.',
};

/**
 * German text for a failed tool call. Tool errors arrive as `CODE: message` or as a bare code;
 * unknown ones are shown as they are.
 *
 * @param {string|null|undefined} error
 * @returns {string|null}
 */
export function toolErrorText(error) {
	if (!error) return null;
	const code = error.split(':')[0].trim();
	return TOOL_ERROR_TEXTS[code] ?? error;
}
